
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("video").forEach(video => {
    video.removeAttribute("controls");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === "controls") {
          video.removeAttribute("controls");
        }
      });
    }).observe(video, { attributes: true });
  });
});

document.querySelectorAll('video').forEach(video => {
  video.removeAttribute('controls');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  
  video.addEventListener('loadedmetadata', () => {
    video.classList.add('ready');
  });
});


document.querySelectorAll('video').forEach(video => {
  video.removeAttribute('controls');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');

  // Force loop
  video.loop = true;

  // Ensure video stays playing if paused by tap
  video.addEventListener('pause', () => {
    video.play().catch(() => {}); // ignore errors
  });

  // MutationObserver to remove controls if theme re-adds them
  new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.attributeName === "controls") video.removeAttribute("controls");
    });
  }).observe(video, { attributes: true });
});